<template>
    <div class="pagination" :class="{pagination_bottom: isBottom}" v-if="items.length >= 1">
        <p>Показано <span>{{ firstItem }}</span> - <span>{{ lastItem }}</span> из <span>{{ quantityItems }}</span></p>
        <ul v-show="quantityPages > 1">
            <li><a class="prev" @click="changePageByNumber(currentPage - 1)" :class="{inactive: currentPage === 1}"></a></li>
            <li v-if="hasFirst"><a @click="changePageByNumber(1)">1</a></li>
            <li v-if="hasPreFirst" class="dots">...</li>
            <li v-for="page in pages"><a :class="{ 'active': page === currentPage }"
                                         @click="changePageByNumber(page)">{{ page }}</a></li>
            <li v-if="hasPreLast" class="dots">...</li>
            <li v-if="hasLast"><a @click="changePageByNumber(quantityPages)">{{ quantityPages }}</a></li>
            <li><a class="next" @click="changePageByNumber(currentPage + 1)" :class="{inactive: currentPage === quantityPages}"></a></li>
        </ul>
    </div>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'

  const {mapActions, mapState, mapMutations, mapGetters} = createNamespacedHelpers('mainPage')

  export default {
    props: ['isBottom', 'params'],
    name: 'Pagination',
    data() {
      return {
        pageRange: 2,
      }
    },
    computed: {
      ...mapState([
        'itemsPerPage',
        'currentPage',
        'quantityItems',
        'quantityPages',
        'items'
      ]),
      firstItem() {
        return (this.currentPage * this.itemsPerPage) - this.itemsPerPage + 1
      },
      lastItem() {
        if (this.currentPage === this.quantityPages) {
          return this.quantityItems
        }
        return (this.currentPage * this.itemsPerPage)
      },
      hasFirst() {
        return this.rangeStart !== 1
      },
      hasPreFirst() {
        return this.rangeStart > 2
      },
      hasPreLast() {
        return this.rangeEnd < this.quantityPages - 1
      },
      hasLast() {
        return this.rangeEnd < this.quantityPages
      },
      pages() {
        let pages = []
        for (let i = this.rangeStart; i <= this.rangeEnd; i++) {
          pages.push(i)
        }
        return pages
      },
      rangeStart() {
        const start = this.currentPage - this.pageRange
        return (start > 0) ? start : 1
      },
      rangeEnd() {
        const end = this.currentPage + this.pageRange
        return (end < this.quantityPages) ? end : this.quantityPages
      }
    },
    methods: {
      ...mapMutations([
        'setPaginationParams',
        'setCurrentPage',
        'setItems'
      ]),
      ...mapActions([
        'getItems',
      ]),
      changePageByNumber(number) {
        if (number !== this.currentPage) {
          this.setCurrentPage(number)
          window.history.pushState({path:window.location.href}, '', `${window.location.origin}${window.location.pathname}?page=${number}`);
          let offset = number * this.itemsPerPage - this.itemsPerPage;
          this.setItems([])
          this.setPaginationParams([
            {name: 'limit', value: this.itemsPerPage},
            {name: 'offset', value: offset}
          ])
          this.getItems();
        }
      },
    },
  }
</script>

<style lang="scss">

    $white: #fff;
    $main-bg-color: #f1f2f7;
    $white-4: #dddddd;
    $white-2: #f8f9fb;
    $grey-4: #d8d9d9;

    $grey-5: #55575c;
    $grey-3: #999a9d;
    $grey-6: #6e7074;
    $grey-2: #46484c;

    $blue: #089cd3;

    $pink: #f27777;

    $green: #61cc40;
    $green-2: #376d27;

    $grey-7: rgba(70, 72, 77, .9);
    $grey-1: #46484c;
    .flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .pagination {
        @extend .flex;
        color: $grey-3;
        font-size: 14px;

        @media screen and (max-width: 479px) {
            flex-direction: column;
            justify-content: center;
        }
        p {
            margin-bottom: 0;
            white-space: nowrap;

            @media screen and (max-width: 479px) {
                margin-bottom: 15px;
            }
            span {
                color: $grey-6;
                font-weight: 500;
            }
        }
        ul {
            display: flex;
            list-style-type: none;
            margin-left: 10px;

            @media screen and (max-width: 479px) {
                margin-left: 0;
                margin-top: 12px;
                padding-left: 0;
            }
            li {
                &:not(:last-child) {
                    margin-right: 1px;
                }
            }
            a {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 28px;
                height: 28px;
                color: $grey-6;
                transition: .5s;
                cursor: pointer;
                border-radius: 50%;
                &:not(.inactive):hover {
                    background: rgba($blue, .1);
                    color: $blue;
                }
            }
            .prev {
                position: relative;
                &:before {
                    content: "";
                    top: 10px;
                    left: 12px;
                    display: block;
                    width: 7px;
                    height: 7px;
                    border: 0 solid;
                    border-width: 0 0 2px 2px;
                    position: absolute;
                    transform: rotate(45deg);
                }
            }
            .next {
                position: relative;
                &:before {
                    content: "";
                    top: 10px;
                    left: 8px;
                    display: block;
                    width: 7px;
                    height: 7px;
                    border: 0 solid;
                    border-width: 2px 2px 0 0;
                    position: absolute;
                    transform: rotate(45deg);
                }
            }
            .inactive {
                opacity: .6;
                pointer-events: none;
                &:hover {
                    background: transparent !important;
                }
            }
            .active {
                background: $blue;
                color: $white;
            }
        }
        &.pagination_bottom {
            padding: 16px 22px;
            background-color: $white;
        }
    }


</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue